import { render, staticRenderFns } from "./member_vip_edit.vue?vue&type=template&id=5db3f274&scoped=true"
import script from "./member_vip_edit.vue?vue&type=script&lang=js"
export * from "./member_vip_edit.vue?vue&type=script&lang=js"
import style0 from "./member_vip_edit.vue?vue&type=style&index=0&id=5db3f274&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3f274",
  null
  
)

export default component.exports